import type { FC, ReactNode } from "preact/compat";

export type AnimateProps = {
  children: ReactNode;
  duration?: number;
  animate?: boolean;
};

export const FadeIn: FC<AnimateProps> = ({
  children,
  duration = 1500,
  animate,
}) => {
  return (
    <div
      className={`ease-in-out ${
        animate ? "opacity-100" : "opacity-0"
      } animate-fade-in`}
      style={{
        transitionProperty: "opacity",
        transitionDuration: `${duration}ms`,
        display: `${animate ? "block" : "none"}`,
        animationName: "fadeIn",
        animationDuration: `${duration}ms`,
      }}
    >
      {children}
    </div>
  );
};
